export default __webpack_public_path__ + "static/media/Sandia.c517a357.png";